module.exports = __webpack_public_path__ + "static/media/saved-penalty.svg.23eeecd6.png";